<template>
  <b-card title="อัปโหลดภาพกิจกรรม">
    <b-form-group
      label="ภาพกิจกรรม"
      label-for="input-1"
      description="รองรับเฉพาะไฟล์ .JPG, .PNG ขนาดไม่เกิน 5 เมกะไบต์เท่านั้น"
    >
      <b-form-file
        id="input-1"
        v-model="file.image"
        accept=".jpg, .png"
        placeholder="เลือกไฟล์..."
        drop-placeholder="วางไฟล์ลงที่นี่.."
        @input="$emit('input', $event)"
      />
    </b-form-group>
    <b-form-group
      class="mb-0"
      label="คำอธิบายรูปภาพ"
      label-for="input-formatter"
      description="ความยาวตั้งแต่ 3 ตัวอักษรขึ้นไป"
    >
      <b-form-input
        id="input-formatter"
        v-model="file.caption"
        placeholder="เพิ่มคำอธิบายรูปภาพ"
      />
    </b-form-group>
    <br>
    <b-button block variant="primary" @click="uploadFile(file)">
      <b-spinner v-if="isUploading" class="mr-1" small />
      <font-awesome-icon v-else icon="file-upload" />
      <template v-if="isUploading">กำลังอัปโหลดไฟล์...</template>
      <template v-else>อัปโหลดไฟล์</template>
    </b-button>
  </b-card>
</template>

<script>
export default {
  props: {
    isUploading: {
      type: Boolean,
      required: true,
      default: false
    }
  },
  data () {
    return {
      file: {
        image: '',
        caption: ''
      }
    }
  },
  methods: {
    uploadFile (file) {
      if (file.image === '' || file.image === null) {
        this.$bvToast.toast('กรุณาเลือกไฟล์รูปภาพที่ต้องการอัปโหลด', {
          title: 'แจ้งเตือน',
          variant: 'danger',
          solid: true
        })
        return
      }

      if (file.image.size / 1024 / 1024 > 5) {
        this.$bvToast.toast('ไม่สามารถอัปโหลดรูปภาพที่มีขนาดเกิน 5 เมกะไบต์ได้', {
          title: 'แจ้งเตือน',
          variant: 'danger',
          solid: true
        })
        return
      }

      this.$emit('submit', file)
    }
  }
}
</script>

<style>

</style>
